<p-floatLabel>
  <p-select #serviceTypeSelector
    id="serviceTypeSelector"
    name="serviceTypeSelector"
    [options]="serviceTypes"
    [(ngModel)]="selectedServiceType"
    [showClear]="true"
    [checkmark]="true"
    [filter]="true"
    styleClass="w-100"
    [disabled]="isDisabled"
    (onChange)="onSelected()"
    optionLabel="name">
    <ng-template let-option pTemplate="item">
      {{ option?.name }}
    </ng-template>
  </p-select>
  <label for="serviceTypeSelector">
    <app-label-content [isRequired]="isRequired">
      {{ l('::ServiceType') }}
    </app-label-content>
  </label>
</p-floatLabel>